// extracted by mini-css-extract-plugin
module.exports = {"article":"InsuranceDetailGuideList_article__ycrgg","point-color":"InsuranceDetailGuideList_point-color___Vfbz","item":"InsuranceDetailGuideList_item__B4L1V"};